export default __webpack_public_path__ + "static/media/transmission_grey.da981a30.svg";